// import React, { useState, useEffect } from "react";
import React from "react";
import "./AboutContent.css";

const AboutContent = ({
    className, 
    title, 
    body, 
    image, 
    colorMode = "colorWhite",
    classSpacer
}) => {

    return (
        <>
            
            <div className={`column is-flex is-flex-direction-column ${className}`}>
                <div className="columns is-gapless">
                    {/* Text content on the left */}
                    
                    <div className={`${classSpacer} column is-3`}>
                        <h1 className={`about ${colorMode}`}>{title}</h1>
                        <p className={`pt-5 about ${colorMode}`}>{body}</p>
                    </div>
                    
                    <div className="column is-1 hide-mobile">   
                    </div>
                    
                    <div className="mt-5 p-0 column is-8-desktop is-12-mobile">
                    {/* Photo widget on the right */}
                        <div className="m-0 p-0 photo-widget-container">
                            {/* Main image */}
                            {image && (
                                <img 
                                    src={image} 
                                    alt="Kinder's"
                                    className="m-0 p-0 square-image" 
                                />
                            )}
                        </div>
                    </div>
                    
                </div>
            </div>
        </>
    );
}

export default AboutContent;